import { render } from "./schedules_view_tab.vue?vue&type=template&id=4884ddc4"
import script from "./schedules_view_tab.vue?vue&type=script&lang=js"
export * from "./schedules_view_tab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__